import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import VoteFullSize from './components/VoteFullSize/VoteFullSize';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';

import defaultBackground from './assets/images/bg.webp';

function App() {
  const { currentState, isVisible, voteState, voteId } = useVote();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    questionFontSize,
    answerFontSize,
    varNumFontSize,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode],
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {(currentState === 'S1' || currentState === 'S2') && (
          <motion.div
            key="advt"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            exit={{ opacity: 0 }}
          >
            {advt_info && <AdvtFullSize advtInfo={advt_info} />}
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {(currentState === 'S1' || currentState === 'S2') && (
          <motion.div
            key={`${voteId}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            exit={{ opacity: 0 }}
            className="titre-wrapper"
          >
            {!voteState?.variants &&
              (currentState === 'S1' || currentState === 'S2') && (
                <VoteFullSize
                  variants={voteState?.vars}
                  title={voteState?.title}
                  withResults={true}
                  currentState={currentState}
                  questionFontSize={questionFontSize}
                  answerFontSize={answerFontSize}
                  varNumFontSize={varNumFontSize}
                />
              )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
